import React from 'react';
import Dropdown from 'antd/lib/dropdown';
import {
    EyeInvisibleFilled, EyeOutlined, LockFilled, MoreOutlined, RightOutlined, UnlockOutlined,
} from '@ant-design/icons';

import CVATTooltip from 'components/common/cvat-tooltip';
import { t } from 'utils/i18n';

interface Props {
    name: string;
    count: number;
    color: string;
    open: boolean;
    hidden: boolean;
    locked: boolean;
    onToggle(): void;
    onHide(hidden: boolean): void;
    onLock(locked: boolean): void;
    // the destructive actions live here, out of the way of a stray click
    menu?: JSX.Element;
}

// one category of a grouped list: chevron, colour, name and count; the toggles show on hover or when set
export default function CategoryRow(props: Props): JSX.Element {
    const {
        name, count, color, open, hidden, locked, onToggle, onHide, onLock, menu,
    } = props;
    return (
        <div className={`cvat-category-row${hidden ? ' cvat-category-row-hidden' : ''}`}>
            <button type='button' className='cvat-category-toggle' aria-expanded={open} onClick={onToggle}>
                <RightOutlined className={`cvat-category-chevron${open ? ' cvat-category-chevron-open' : ''}`} />
                <span className='cvat-category-color' style={{ background: color }} />
                <span className='cvat-category-name'>{name}</span>
                <span className='cvat-category-count'>{count}</span>
            </button>
            <span className='cvat-category-actions'>
                <CVATTooltip title={locked ? t('Unlock all') : t('Lock all')}>
                    {locked ? (
                        <LockFilled className='cvat-category-action cvat-category-action-on' aria-label={t('Unlock {name}', { name })} onClick={() => onLock(false)} />
                    ) : (
                        <UnlockOutlined className='cvat-category-action' aria-label={t('Lock {name}', { name })} onClick={() => onLock(true)} />
                    )}
                </CVATTooltip>
                <CVATTooltip title={hidden ? t('Show all') : t('Hide all')}>
                    {hidden ? (
                        <EyeInvisibleFilled className='cvat-category-action cvat-category-action-on' aria-label={t('Show {name}', { name })} onClick={() => onHide(false)} />
                    ) : (
                        <EyeOutlined className='cvat-category-action' aria-label={t('Hide {name}', { name })} onClick={() => onHide(true)} />
                    )}
                </CVATTooltip>
                {menu && (
                    <Dropdown overlay={menu} trigger={['click']} placement='bottomRight' destroyPopupOnHide>
                        <MoreOutlined className='cvat-category-action' aria-label={t('More for {name}', { name })} role='button' />
                    </Dropdown>
                )}
            </span>
        </div>
    );
}
